import React from 'react'
import { createContext, QueryParamsObserver } from 'labguard-cdk'
import gql from 'graphql-tag'
import { useQuery } from 'react-apollo'

const query = gql`
  query now {
    now
  }
`

/**
 * Context used to manage the current date, refreshed once a minute : "now"
 */
export default createContext(
  Provider =>
    function NowContext(props) {
      // get data from server
      const { data: { now } = {} } = useQuery(query)

      // compute difference between client and server time, defaults to 0 if no server time yet
      const delta = React.useMemo(() => (now ? Date.now() - new Date(now).getTime() : 0), [now])

      // provide state and handler to refresh the current date
      const [timestamp, refresh] = React.useReducer(Date.now, undefined, Date.now)

      // compute actual date updated when timestamp changes
      const value = React.useMemo(() => new Date(timestamp + delta), [delta, timestamp])

      // get period from query params
      const { from, to } = QueryParamsObserver.useValue()

      // refresh when `from` changes but not `to`
      React.useEffect(() => {
        from && !to && refresh()
      }, [from, to])

      // provide value and handler to refresh to Provider component
      return (
        <Provider
          value={{
            now: value,
            refresh,
          }}
          {...props}
        />
      )
    }
)
